import React from 'react';
import classNames from 'classnames';
import { Icon } from './../../index';
import {IconName} from '@fortawesome/fontawesome-common-types';

/**
 * Button component
 * @param props
*/
export default function Button(props: {
    children?: React.ReactNode,
    active?: boolean, // shows a different background
    highlight?: boolean, // shows a different text color
    color?: string, // primary, white, black, warning, success, danger
    loading?: boolean, // replaces text with a spinner
    fullwidth?: boolean, // stretch the button all the way
    icon?: string, // add a icon before the text
    disabled?: boolean,
    size?: 'lg' | 'md' | 'sm',
    className?: string,
    onClick?: () => void,
    type?: 'submit' | 'reset' | 'button'
}) {
    const classes = classNames('button', props.className, {
        'is-active': !!props.active,
        'has-text-primary': !!props.highlight,
        'is-loading': !!props.loading,
        'is-fullwidth': !!props.fullwidth,
        [`is-${props.color}`]: props.color?.length,
        [`is-${props.size}`]: props.size?.length
    });

    return (
        <button
            type={props.type || 'button'}
            className={classes}
            disabled={props.disabled}
            onClick={props.onClick}>
            {props.icon ? <Icon name={props.icon as IconName} className={props.loading ? 'fa-spin' : ''}/> : ''}
            {props.children}
        </button>
    );
}